/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { AboutChild, Eligibility, InputData } from '../_common/data/input-data';
import { Path } from  "../_common/constant/page-const";
import { Transition1Validation } from './transition_1.validator';
import { Confirm } from 'src/refresh/service/constant';

@Component({ 
      selector: 'transition_1',
      templateUrl: './transition_1.component.html',
      styleUrls: ['./transition_1.component.less']
})
export class Transition1Component extends FormBaseComponent implements OnInit {

      eligibility : Eligibility;
      aboutChild : AboutChild;
      
      constructor( protected router: Router ,
                   public timerService:TimerService,
                   public data:InputData ) {

                  super(router,timerService);  
                  super.setNextPage(Path.BirthCertificate,Path.FinalReview);
                  this.eligibility = data.eligibility;
                  this.aboutChild = data.aboutChild;

                  super.setValidator(new Transition1Validation(this));

                  InputData.currentPageIdx = 17;
                  if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false; 
      }
      
      public ngOnInit() {
             super.forwardNext(this.data.eligibility.listedParentCount);
      }
      

      noException() {
            return !(this.aboutChild.isChildDeceased == 'Y' ||
                     this.eligibility.isCustodyOtherThanParent == 'Y');
      }
}
